<template>
  <div>
    <v-btn
      v-permission="permissions"
      color="error"
      :disabled="disabled"
      class="ml-2"
      :class="{ w100: $vuetify.breakpoint.lgAndDown }"
      x-small
      @click="$dialog.show('remove-confirmation', { itemId })"
    >
      <v-icon left>delete</v-icon> Удалить
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'delete-button',
  props: {
    permissions: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
    itemId: String,
  },
};
</script>

<style scoped>

</style>
